$( $ => {
  const section = $( '.bs-section--home-answers-to-questions' );
  if ( section.length === 0 ) { return; }
  const addDataId = ( p, cls, section ) => {
    const clzs = p.attr( 'class' ).split( /\s+/ ),
      clzInd = clzs.indexOf( cls ),
      clzName = clzs[clzInd];
    p.attr( 'data-id', clzName );
    if ( p.hasClass( 'active' ) ) {
      section.attr( 'data-active-tab', clzName );
      if ( clzName === 'tab-customer' ) {
        $( '.bs-tab-slider--home-answers-to-questions-customer' ).addClass( 'active-tab-slider' );
      } else {
        $( '.bs-tab-slider--home-answers-to-questions-sales' ).addClass( 'active-tab-slider' );
      }
    }
  };
  const toggleActive = ( section, toggleWrapper ) => {
    toggleWrapper.find( 'p' ).toggleClass( 'active' );
    const activeTab = toggleWrapper.find( 'p.active' ).attr( 'data-id' );
    section.attr( 'data-active-tab', activeTab );
    if ( activeTab === 'tab-customer' ) {
      $( '.bs-tab-slider--home-answers-to-questions-customer' ).addClass( 'active-tab-slider' );
      $( '.bs-tab-slider--home-answers-to-questions-sales' ).removeClass( 'active-tab-slider' );
    } else {
      $( '.bs-tab-slider--home-answers-to-questions-sales' ).addClass( 'active-tab-slider' );
      $( '.bs-tab-slider--home-answers-to-questions-customer' ).removeClass( 'active-tab-slider' );
    }
  };
  const toggleWrapper = section.find( '.bs-div--home-answers-to-questions-toggle' ),
    salesLabel = toggleWrapper.find( 'p.tab-sales' ),
    customerLabel = toggleWrapper.find( 'p.tab-customer' );

  addDataId( salesLabel, 'tab-sales', section );
  addDataId( customerLabel, 'tab-customer', section );

  toggleWrapper.find( 'p, .bs-pro-button' ).each( ( ind, el ) => {
    $( el ).on( 'click', e => {
      e.preventDefault();
      toggleActive( section, toggleWrapper );
    } );
  } );
} );